const investigationExtraQuestions = {
    "Upper GI Endoscopy": [
        {
            label: "Priority for Upper GI Endoscopy",
            controlType: "radio button",
            options: ["Suspected cancer", "Urgent", "Routine"],
            required: true,
        },

        {
            label: "Priority for Upper GI Endoscopy",
            controlType: "radio button",
            options: ["Suspected cancer", "Urgent", "Routine"],
            required: false,
        },

        {
            label: "Has the patient had an MI within the last 6 weeks",
            controlType: "radio button",
            options: ["Yes", "No"],
            required: false,
        },

        {
            label: "Does the patient have a prosthetic heart valve",
            controlType: "radio button",
            options: ["Yes", "No"],
            required: false,
        },

        {
            label: "Has the patient had an MI within the last 6 weeks",
            controlType: "radio button",
            options: ["Yes", "No"],
            required: false,
        },

        {
            label: "Should PPI be stopped for the procedure",
            controlType: "radio button",
            options: ["Yes", "No", "N/A"],
            required: false,
        },

        {
            label: "Is the patient diabetic",
            controlType: "radio button",
            options: ["No", "Diet controlled", "Oral medication", "Insulin"],
            required: false,
        },

        {
            label: "Has the patient had an MI within the last 6 weeks",
            controlType: "radio button",
            options: ["Yes", "No"],
            required: false,
        },

        {
            label: "Infection Risk",
            controlType: "radio button",
            options: ["Yes", "No"],
            required: false,
        },

        {
            label: "Is the patient taking anticoagulants",
            controlType: "checkbox group extra wide",
            options: [
                "No",
                "Clopigogrel",
                "Dabigatran",
                "DOAC",
                "Prasugrel",
                "Sinthrone",
                "Ticegrelor",
                "Warfarin",
            ],
            required: true,
        },

        {
            label: "Does the patient have a pacemaker",
            controlType: "radio button",
            options: ["Yes", "No"],
            required: false,
        },

        {
            label: "Has the patient have mental capacity to give consent",
            controlType: "radio button",
            options: ["Yes", "No"],
            required: false,
        },

        {
            label: "Is an interpreter required",
            controlType: "radio button",
            options: ["Yes", "No"],
            required: false,
        },

        {
            label: "Any additional information for endoscopy",
            controlType: "text area",
            options: ["Yes", "No"],
            required: false,
        },
    ],

    "Bone XR": [
        {
            label: "Priority for bone X ray",
            controlType: "radio button",
            options: ["Suspected cancer", "Urgent", "Routine"],
            required: false,
        },

        {
            label: "Bone area to be X-rayed",
            controlType: "text",
            options: [],
            required: false,
        },

        {
            label: "Side (bone X ray)",
            controlType: "radio button",
            options: ["Right ", "Left ", "Bilateral", "N/A"],
            required: false,
        },

        {
            label: "Is the patient pregnant",
            controlType: "radio button",
            options: ["Yes", "No", "Unsure"],
            required: false,
        },

        {
            label: "Travel",
            controlType: "radio button",
            options: ["Own arrangements", "Ambulance", "Patient transport"],
            required: false,
        },

        {
            label: "Any other comments regarding bone XR",
            controlType: "text area",
            options: ["Yes", "No", "Unsure"],
            required: false,
        },
    ],

    "Chest X Ray": [
        {
            label: "Priority for Chest X ray",
            controlType: "radio button",
            options: ["Suspected cancer", "Urgent", "Routine"],
            required: false,
        },

        {
            label: "Is the patient pregnant",
            controlType: "radio button",
            options: ["Yes", "No", "Unsure"],
            required: false,
        },

        {
            label: "Travel",
            controlType: "radio button",
            options: ["Own arrangements", "Ambulance", "Patient transport"],
            required: false,
        },

        {
            label: "Any other comments regarding Chest XR",
            controlType: "text area",
            options: [],
            required: false,
        },
    ],
    "CT Abdomen": [
        {
            label: "Priority for CT abdomen",
            controlType: "radio button",
            options: ["Suspected cancer", "Urgent", "Routine"],
            required: false,
        },

        {
            label: "Is there a known contraindication to X ray contrast",
            controlType: "radio button",
            options: ["Yes", "No"],
            required: false,
        },

        {
            label: "Has the patient had renal function tests done / arranged in the last 3 months",
            controlType: "radio button",
            options: ["Yes", "No"],
            required: false,
        },

        {
            label: "Does the patient have renal impairment",
            controlType: "radio button",
            options: ["Yes", "No"],
            required: false,
        },

        {
            label: "Does the patient have heart failure",
            controlType: "radio button",
            options: ["Yes", "No"],
            required: false,
        },

        {
            label: "Is the patient taking nephrotoxic drugs",
            controlType: "radio button",
            options: ["Yes", "No"],
            required: false,
        },

        {
            label: "Is the patient taking nephrotoxic drugs",
            controlType: "radio button",
            options: ["Suspected cancer", "Urgent", "Routine"],
            required: false,
        },

        {
            label: "Is the patient need sedation for CT scanning",
            controlType: "radio button",
            options: ["Yes", "No"],
            required: false,
        },

        {
            label: "Is the patient diabetic",
            controlType: "radio button",
            options: ["No", "Diet controlled", "Oral medication", "Insulin"],
            required: false,
        },

        {
            label: "Is the patient pregnant",
            controlType: "radio button",
            options: ["Yes", "No", "Unsure"],
            required: false,
        },

        {
            label: "Travel",
            controlType: "radio button",
            options: ["Own arrangements", "Ambulance", "Patient transport"],
            required: false,
        },

        {
            label: "Any other comments regarding Abdominal CT",
            controlType: "text area",
            options: [],
            required: false,
        },
    ],

    "CT Chest": [
        {
            label: "Priority for CT chest",
            controlType: "radio button",
            options: ["Suspected cancer", "Urgent", "Routine"],
            required: false,
        },

        {
            label: "Is there a known contraindication to X ray contrast",
            controlType: "radio button",
            options: ["Yes", "No"],
            required: false,
        },

        {
            label: "Has the patient had renal function tests done / arranged in the last 3 months",
            controlType: "radio button",
            options: ["Yes", "No"],
            required: false,
        },

        {
            label: "Does the patient have renal impairment",
            controlType: "radio button",
            options: ["Yes", "No"],
            required: false,
        },

        {
            label: "Does the patient have heart failure",
            controlType: "radio button",
            options: ["Yes", "No"],
            required: false,
        },

        {
            label: "Is the patient taking nephrotoxic drugs",
            controlType: "radio button",
            options: ["Yes", "No"],
            required: false,
        },

        {
            label: "Is the patient taking nephrotoxic drugs",
            controlType: "radio button",
            options: ["Suspected cancer", "Urgent", "Routine"],
            required: false,
        },

        {
            label: "Is the patient need sedation for CT scanning",
            controlType: "radio button",
            options: ["Yes", "No"],
            required: false,
        },

        {
            label: "Is the patient diabetic",
            controlType: "radio button",
            options: ["No", "Diet controlled", "Oral medication", "Insulin"],
            required: false,
        },

        {
            label: "Is the patient pregnant",
            controlType: "radio button",
            options: ["Yes", "No", "Unsure"],
            required: false,
        },

        {
            label: "Travel",
            controlType: "radio button",
            options: ["Own arrangements", "Ambulance", "Patient transport"],
            required: false,
        },

        {
            label: "Any other comments regarding chest CT",
            controlType: "text area",
            options: [],
            required: false,
        },
    ],
    "CT brain": [
        {
            label: "Priority for CT Brain",
            controlType: "radio button",
            options: ["Suspected cancer", "Urgent", "Routine"],
            required: false,
        },

        {
            label: "Is there a known contraindication to X ray contrast",
            controlType: "radio button",
            options: ["Yes", "No"],
            required: false,
        },

        {
            label: "Has the patient had renal function tests done / arranged in the last 3 months",
            controlType: "radio button",
            options: ["Yes", "No"],
            required: false,
        },

        {
            label: "Does the patient have renal failure",
            controlType: "radio button",
            options: ["Yes", "No"],
            required: false,
        },

        {
            label: "Does the patient have heart failure",
            controlType: "radio button",
            options: ["Yes", "No"],
            required: false,
        },

        {
            label: "Is the patient taking nephrotoxic drugs",
            controlType: "radio button",
            options: ["Yes", "No"],
            required: false,
        },

        {
            label: "Is the patient need sedation for CT scanning",
            controlType: "radio button",
            options: ["Yes", "No"],
            required: false,
        },

        {
            label: "Is the patient diabetic",
            controlType: "radio button",
            options: ["No", "Diet controlled", "Oral medication", "Insulin"],
            required: false,
        },

        {
            label: "Is the patient pregnant",
            controlType: "radio button",
            options: ["Yes", "No", "Unsure"],
            required: false,
        },

        {
            label: "Travel",
            controlType: "radio button",
            options: ["Own arrangements", "Ambulance", "Patient transport"],
            required: false,
        },

        {
            label: "Any other comments regarding Brain CT",
            controlType: "text area",
            options: [],
            required: false,
        },
    ],

    "Abdominal Ultrasound": [
        {
            label: "Priority for Abdominal ultrasound",
            controlType: "radio button",
            options: ["Suspected cancer", "Urgent", "Routine"],
            required: false,
        },

        {
            label: "Is the patient diabetic",
            controlType: "radio button",
            options: ["No", "Diet controlled", "Oral medication", "Insulin"],
            required: false,
        },

        {
            label: "Is the patient pregnant",
            controlType: "radio button",
            options: ["Yes", "No", "Unsure"],
            required: false,
        },

        {
            label: "LMP if relevant",
            controlType: "Date",
            options: [],
            required: false,
        },

        {
            label: "Travel",
            controlType: "radio button",
            options: ["Own arrangements", "Ambulance", "Patient transport"],
            required: false,
        },

        {
            label: "Any other comments regarding Abdominal Ultrasound",
            controlType: "text area",
            options: [],
            required: false,
        },
    ],

    "Pelvic Ultrasound": [
        {
            label: "Priority for Pelvic ultrasound",
            controlType: "radio button",
            options: ["Suspected cancer", "Urgent", "Routine"],
            required: false,
        },

        {
            label: "Is the patient diabetic",
            controlType: "radio button",
            options: ["No", "Diet controlled", "Oral medication", "Insulin"],
            required: false,
        },

        {
            label: "Is the patient pregnant",
            controlType: "radio button",
            options: ["Yes", "No", "Unsure"],
            required: false,
        },

        {
            label: "LMP if relevant",
            controlType: "Date",
            options: [],
            required: false,
        },

        {
            label: "Travel",
            controlType: "radio button",
            options: ["Own arrangements", "Ambulance", "Patient transport"],
            required: false,
        },

        {
            label: "Any other comments regarding Pelvic Ultrasound",
            controlType: "text area",
            options: [],
            required: false,
        },
    ],

    "Soft Tissue Ultrasound": [
        {
            label: "Priority for Soft Tissue ultrasound",
            controlType: "radio button",
            options: ["Suspected cancer", "Urgent", "Routine"],
            required: false,
        },

        {
            label: "Area of interest for Soft Tissue Ultrasound",
            controlType: "text",
            options: [],
            required: false,
        },

        {
            label: "Is the patient diabetic",
            controlType: "radio button",
            options: ["No", "Diet controlled", "Oral medication", "Insulin"],
            required: false,
        },

        {
            label: "Is the patient pregnant",
            controlType: "radio button",
            options: ["Yes", "No", "Unsure"],
            required: false,
        },

        {
            label: "LMP if relevant",
            controlType: "Date",
            options: [],
            required: false,
        },

        {
            label: "Travel",
            controlType: "radio button",
            options: ["Own arrangements", "Ambulance", "Patient transport"],
            required: false,
        },

        {
            label: "Any other comments regarding Soft Tissue Ultrasound",
            controlType: "text area",
            options: ["Yes", "No", "Unsure"],
            required: false,
        },
    ],

    "Testicular ultrasound": [
        {
            label: "Priority for Testicular ultrasound",
            controlType: "radio button",
            options: ["Suspected cancer", "Urgent", "Routine"],
            required: false,
        },

        {
            label: "Area of interest for Testicular Ultrasound",
            controlType: "text",
            options: [],
            required: false,
        },

        {
            label: "Is the patient diabetic",
            controlType: "radio button",
            options: ["No", "Diet controlled", "Oral medication", "Insulin"],
            required: false,
        },

        {
            label: "Is the patient pregnant",
            controlType: "radio button",
            options: ["Yes", "No", "Unsure"],
            required: false,
        },

        {
            label: "Travel",
            controlType: "radio button",
            options: ["Own arrangements", "Ambulance", "Patient transport"],
            required: false,
        },

        {
            label: "Any other comments regarding Testicular Ultrasound",
            controlType: "text area",
            options: [],
            required: false,
        },
    ],

    "MRI brain":
    [
    {
        label: "Please provide details of any previous MR examinations",
        controlType: "text area",
        options:[],
        required: false,
     },

     {
        label:"Does the patient have any implants?",
        controlType: "checkbox group extra wide",
        options:["No implants","Pacemaker /ICD", "Loop recorder /Reveal device", "Artificial heart valve", "Cochlear implants", "Aneurism clips", "Progrmmable shunt", "Neurostimulators", "Other metal /electronic implant"]

     },

     {
        label:"Please provide any available information on the type, date of insertion and hospital for any implants",
        controlType: "text area",
        options: [],
        required: false,
     },

     {
        label:"Is there a history of potential penetrating eye injury (if yes- please arrange IOFB X Ray",
        contolType: "radio button",
        options: ["Yes", "No"],
        required: false,      
     },

     {
        label:"Please provide any available information on any previous surgery",
        controlType: "text area",
        options: ["Yes", "No"],
        required: false,
    },

    {
        label: "Does the patient have renal impairment",
        controlType: "radio button",
        options: ["Yes", "No"],
        required: false,
    },

    {
        label: "Is the patient diabetic",
        controlType: "radio button",
        options: ["No", "Diet controlled", "Oral medication", "Insulin"],
        required: false,
    },

    {
        label: "Is the patient pregnant",
        controlType: "radio button",
        options: ["Yes", "No", "Unsure"],
        required: false,
    },

    {
        label: "Does the patient weigh over 200kg?",
        controlType: "radio button",
        options: ["Yes", "No"],
        required: false,
    },

    {
        label: "If weight over 200kg- provide exact weight(kg)",
        controlType: "text",
        options: [],
        required: false,
    },

    {
        label: "Is the claustrophobic?",
        controlType: "radio button",
        options: ["Yes", "No"],
        required: false,
    },

   







    ]



    
};
export default investigationExtraQuestions;
